import {Text} from '@rdcomponents/text/text';
import {Card, Skeleton} from 'antd';

import {AdditionalInfo} from '../../../../../../layout/additional-info/additional-info';
import {useCatalogInfo} from '../../../../../../provider/catalogs/catalogs-hook';
import {FormattedNumber} from '../../../../../../provider/locale/formatted-number';
import {Locale} from '../../../../../../provider/locale/locale';
import {RatingDynamicsCompaniesStatsDataType} from '../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';

import * as styles from './rating-history-average-rating-card.scss';

type PropsType =
    | {
          catalogRatingData: RatingDynamicsCompaniesStatsDataType['medianRatingsAverage']['catalogAverages'][number];
          loading?: never;
      }
    | {
          loading: true;
          catalogRatingData?: never;
      };

export function RatingHistoryAverageCatalogRatingCard(props: PropsType): JSX.Element {
    const {catalogRatingData} = props;

    const {getCatalogName} = useCatalogInfo();

    return (
        <Card>
            <div className={styles.RatingHistoryAverageRating}>
                {catalogRatingData ? (
                    <>
                        <AdditionalInfo
                            leftNode={
                                <Text
                                    block
                                    secondary
                                    small
                                    stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMICS__CATALOG_AVERAGE_RATING"
                                    valueMap={{
                                        catalogName: (
                                            <Text bolder small>
                                                {getCatalogName(catalogRatingData.catalog)}
                                            </Text>
                                        ),
                                    }}
                                />
                            }
                        >
                            <Locale stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMICS__OVERALL_MEDIAN_RATING_YEAR_HINT" />
                        </AdditionalInfo>
                        <Text block bolder className={styles.RatingHistoryAverageRating_value}>
                            <FormattedNumber options={{maximumFractionDigits: 1}} value={catalogRatingData.rating} />
                        </Text>
                    </>
                ) : (
                    <>
                        <AdditionalInfo
                            leftNode={
                                <Text
                                    block
                                    secondary
                                    small
                                    stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMICS__CATALOG_AVERAGE_RATING"
                                    valueMap={{
                                        catalogName: <Skeleton.Input active size="small" />,
                                    }}
                                />
                            }
                        >
                            <Locale stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMICS__OVERALL_MEDIAN_RATING_YEAR_HINT" />
                        </AdditionalInfo>
                        <Skeleton.Input active size="large" />
                    </>
                )}
            </div>
        </Card>
    );
}
